import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

interface ControlBarProps {
  children: ReactNode;
  className?: string;
}

export const ControlBar: FC<ControlBarProps> = ({ children, className }) => (
  <div
    className={cx(
      "flex h-[72px] shrink-0 items-center justify-between gap-4 bg-[#EEF2F5] px-8",
      "border-grey-300 jugl__custom-scrollbar-horizontal overflow-x-auto border-b border-l-0 border-r-0 border-t-0 border-solid",
      className
    )}
  >
    {children}
  </div>
);
